import React, { useEffect, useState } from 'react';
import { MdEmail, MdPassword, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { FaUserShield, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useUserAuth } from './context/UserAuthContext';

const Login = () => {
    const { logIn } = useUserAuth();
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    let navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        email: '',
        password: '',
    });

    const formHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setData({ ...data, [name]: value });
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/dashboard/dash_board", { replace: true });
        }
    }, [navigate]);

    const loginHandler = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(
                `${base_url}/api/v1/admin/login`,
                {
                    email: data.email,
                    password: data.password,
                }
            );

            if (response.data.success) {
                logIn(
                    {
                        id: response.data.data.id,
                        email: response.data.data.email
                    },
                    response.data.data.token
                );

                toast.success("Successfully Logged In", {
                    position: "top-right",
                    autoClose: 3000,
                });

                navigate("/dashboard/dash_board", { replace: true });
            }
        } catch (error) {
            console.log(error);
            toast.error(
                error.response?.data?.message || "Login Failed",
                {
                    position: "top-right",
                    autoClose: 4000,
                }
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="min-vh-100 d-flex align-items-center justify-content-center" 
                 style={{ 
                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                     padding: '20px'
                 }}>
                <div className="card shadow-lg animate__animated animate__fadeInUp" 
                     style={{ 
                         width: '100%',
                         maxWidth: '450px',
                         borderRadius: '20px',
                         background: 'white',
                         overflow: 'hidden'
                     }}>
                    {/* Header with gradient */}
                    <div style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '40px 30px',
                        textAlign: 'center'
                    }}>
                        <div className="mb-3">
                            <img 
                                src='https://www.lsstrust.org.in/static/media/lss_logo.89bae2c852b508839c31.png' 
                                alt="Logo"
                                style={{ 
                                    height: '100px', 
                                    width: 'auto',
                                    objectFit: 'contain',
                                    // filter: 'brightness(0) invert(1)'
                                }} 
                            />
                        </div>
                        <h3 className="text-white fw-bold mb-0">Welcome Back</h3>
                        <p className="text-white-50 mb-0" style={{ fontSize: '14px' }}>
                            Sign in to continue to your dashboard
                        </p>
                    </div>

                    {/* Body */}
                    <div className="p-4 p-md-5">
                        <form onSubmit={loginHandler}>
                            {/* Email Field */}
                            <div className="mb-4">
                                <label className="form-label fw-semibold text-secondary" style={{ fontSize: '14px' }}>
                                    Email Address
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-0" 
                                          style={{ borderRadius: '12px 0 0 12px' }}>
                                        <MdEmail style={{ color: '#667eea' }} size={20} />
                                    </span>
                                    <input
                                        type="email"
                                        className="form-control border-0 bg-light"
                                        placeholder="Enter your email"
                                        required
                                        name='email'
                                        onChange={formHandler}
                                        value={data.email}
                                        style={{ 
                                            borderRadius: '0 12px 12px 0',
                                            padding: '12px 15px',
                                            fontSize: '15px'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Password Field */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold text-secondary" style={{ fontSize: '14px' }}>
                                    Password
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-0" 
                                          style={{ borderRadius: '12px 0 0 12px' }}>
                                        <MdPassword style={{ color: '#667eea' }} size={20} />
                                    </span>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control border-0 bg-light"
                                        placeholder="Enter your password"
                                        required
                                        name='password'
                                        onChange={formHandler}
                                        value={data.password}
                                        style={{ 
                                            borderRadius: '0 12px 12px 0',
                                            padding: '12px 15px',
                                            fontSize: '15px'
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className="input-group-text bg-light border-0"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{ 
                                            borderRadius: '0 12px 12px 0',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {showPassword ? 
                                            <MdVisibilityOff style={{ color: '#6c757d' }} size={20} /> : 
                                            <MdVisibility style={{ color: '#6c757d' }} size={20} />
                                        }
                                    </button>
                                </div>
                            </div>

                            {/* Forgot Password Link */}
                            {/* <div className="text-end mb-4">
                                <a href="#" className="text-decoration-none" 
                                   style={{ 
                                       color: '#667eea', 
                                       fontSize: '14px',
                                       fontWeight: '500'
                                   }}>
                                    Forgot Password?
                                </a>
                            </div> */}

                            {/* Login Button */}
                            <button
                                type="submit"
                                className="btn btn-primary w-100 fw-bold py-3"
                                disabled={loading}
                                style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    fontSize: '16px',
                                    letterSpacing: '0.5px',
                                    transition: 'transform 0.2s',
                                }}
                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                        Logging in...
                                    </>
                                ) : (
                                    'Sign In'
                                )}
                            </button>

                            {/* Footer */}
                            <div className="text-center mt-4">
                                <p className="text-muted" style={{ fontSize: '13px' }}>
                                    &copy; {new Date().getFullYear()} LSS Trust. All rights reserved.
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default Login;